var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDataVariables01 = function SvgIconDataVariables01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_data_variables-01_svg2__a",
    x1: -18.35,
    x2: 162.89,
    y1: 85.71,
    y2: -9.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_data_variables-01_svg2__a",
    id: "icon_data_variables-01_svg2__b",
    x1: -25.48,
    x2: 155.75,
    y1: 72.07,
    y2: -22.73
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_data_variables-01_svg2__a",
    id: "icon_data_variables-01_svg2__c",
    x1: -8.89,
    x2: 172.35,
    y1: 103.8,
    y2: 9
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_data_variables-01_svg2__a",
    id: "icon_data_variables-01_svg2__d",
    x1: 3.88,
    x2: 185.11,
    y1: 128.21,
    y2: 33.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_data_variables-01_svg2__a",
    id: "icon_data_variables-01_svg2__e",
    x1: -11.18,
    x2: 170.05,
    y1: 99.42,
    y2: 4.62
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_data_variables-01_svg2__a",
    id: "icon_data_variables-01_svg2__f",
    x1: -40.57,
    x2: 140.66,
    y1: 43.22,
    y2: -51.58
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_data_variables-01_svg2__a",
    id: "icon_data_variables-01_svg2__g",
    x1: -27.79,
    x2: 153.45,
    y1: 67.66,
    y2: -27.13
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_data_variables-01_svg2__a",
    id: "icon_data_variables-01_svg2__h",
    x1: -18.32,
    x2: 162.91,
    y1: 85.75,
    y2: -9.05
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_data_variables-01_svg2__a",
    id: "icon_data_variables-01_svg2__i",
    x1: -18.44,
    x2: 162.79,
    y1: 85.53,
    y2: -9.26
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M49.98 18.57c-3.3 0-6.55.55-9.65 1.6-.75.25-1.2 1.1-.95 1.9s1.1 1.2 1.85.95c2.8-.95 5.75-1.45 8.75-1.45 15.24 0 27.69 12.74 27.69 28.39S65.28 78.35 49.98 78.35 22.29 65.61 22.29 49.96s4.9-18.89 13.09-24.14c.7-.45.9-1.35.45-2.1-.45-.7-1.35-.9-2-.5-4.35 2.75-7.95 6.65-10.49 11.19-2.6 4.7-4 10.04-4 15.49 0 17.34 13.74 31.43 30.63 31.43S80.6 67.24 80.6 49.9 66.86 18.47 49.97 18.47v.1Z",
    style: {
      fill: "url(#icon_data_variables-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.76 23.46c.25.25.6.35.95.35s.85-.2 1.15-.55l9.7-11.99h5.15c.6 1.95 2.4 3.35 4.5 3.35 2.6 0 4.75-2.2 4.75-4.85s-2.15-4.85-4.75-4.85-3.9 1.4-4.5 3.35h-5.85c-.45 0-.85.2-1.15.55L73.57 21.36c-.5.65-.45 1.6.2 2.1ZM95.2 7.87c1 0 1.8.85 1.8 1.85s-.8 1.85-1.8 1.85-1.8-.85-1.8-1.85.8-1.85 1.8-1.85",
    style: {
      fill: "url(#icon_data_variables-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.2 45.15c-2.1 0-3.9 1.4-4.5 3.35h-4.95c-.8 0-1.45.65-1.45 1.5s.65 1.5 1.45 1.5h4.95c.6 1.95 2.4 3.35 4.5 3.35s4.75-2.2 4.75-4.85-2.15-4.85-4.75-4.85m0 6.7c-1 0-1.8-.85-1.8-1.85s.8-1.85 1.8-1.85S97 49 97 50s-.8 1.85-1.8 1.85",
    style: {
      fill: "url(#icon_data_variables-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.2 85.38c-2.1 0-3.9 1.4-4.5 3.35h-5.15l-9.7-11.99c-.5-.65-1.45-.75-2.05-.2s-.7 1.5-.2 2.1l10.14 12.54c.3.35.7.55 1.15.55h5.85c.6 1.95 2.4 3.35 4.5 3.35s4.75-2.2 4.75-4.85-2.15-4.85-4.75-4.85h-.05Zm0 6.75c-1 0-1.8-.85-1.8-1.85s.8-1.85 1.8-1.85 1.8.85 1.8 1.85-.8 1.85-1.8 1.85",
    style: {
      fill: "url(#icon_data_variables-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.19 76.54c-.6-.55-1.55-.45-2.05.2l-9.7 11.99H9.29c-.6-1.95-2.4-3.35-4.5-3.35-2.6 0-4.75 2.2-4.75 4.85s2.15 4.85 4.75 4.85 3.9-1.4 4.5-3.35h5.85c.45 0 .85-.2 1.15-.55l10.14-12.54c.5-.65.45-1.6-.2-2.1h-.05ZM4.75 92.13c-1 0-1.8-.85-1.8-1.85s.8-1.85 1.8-1.85 1.8.85 1.8 1.85-.8 1.85-1.8 1.85",
    style: {
      fill: "url(#icon_data_variables-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.75 14.62c2.1 0 3.9-1.4 4.5-3.35h5.15l9.7 11.99c.3.35.7.55 1.15.55s.65-.1.95-.35c.6-.55.7-1.5.2-2.1L16.26 8.82c-.3-.35-.7-.55-1.15-.55H9.26c-.6-1.95-2.4-3.35-4.5-3.35C2.16 4.87.01 7.07.01 9.72s2.15 4.85 4.75 4.85v.05Zm0-6.75c1 0 1.8.85 1.8 1.85s-.8 1.85-1.8 1.85-1.8-.85-1.8-1.85.8-1.85 1.8-1.85",
    style: {
      fill: "url(#icon_data_variables-01_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.75 54.85c2.1 0 3.9-1.4 4.5-3.35h4.95c.8 0 1.45-.65 1.45-1.5s-.65-1.5-1.45-1.5H9.25c-.6-1.95-2.4-3.35-4.5-3.35S0 47.3 0 50s2.15 4.85 4.75 4.85m0-6.7c1 0 1.8.85 1.8 1.85s-.8 1.85-1.8 1.85S2.95 51 2.95 50s.8-1.85 1.8-1.85",
    style: {
      fill: "url(#icon_data_variables-01_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.42 27.06h-4.85c-1.4 0-2.55 1.2-2.55 2.65v3.05c-1.15.35-2.3.85-3.35 1.45l-2.1-2.15c-1-1.05-2.65-1.05-3.65 0l-3.45 3.5c-1 1.05-1 2.7 0 3.75l2.1 2.15c-.6 1.1-1.05 2.25-1.4 3.45h-3c-1.4 0-2.55 1.2-2.55 2.65v5c0 1.45 1.15 2.65 2.55 2.65h3c.35 1.2.8 2.35 1.4 3.45l-2.1 2.15c-.5.5-.75 1.15-.75 1.85s.25 1.35.75 1.85l3.45 3.5c.5.5 1.15.75 1.8.75s1.35-.25 1.8-.75l2.1-2.15c1.05.6 2.2 1.1 3.35 1.45v3.05c0 1.45 1.15 2.65 2.55 2.65h4.85c1.4 0 2.55-1.2 2.55-2.65v-3.05c1.15-.35 2.3-.85 3.35-1.45l2.1 2.15c1 1.05 2.65 1.05 3.65 0l3.45-3.5c.5-.5.75-1.15.75-1.85s-.25-1.35-.75-1.85l-2.1-2.15c.6-1.1 1.05-2.25 1.4-3.45h3c1.4 0 2.55-1.2 2.55-2.65v-5c0-1.45-1.15-2.65-2.55-2.65h-3c-.35-1.2-.8-2.35-1.4-3.45l2.1-2.15c1-1.05 1-2.7 0-3.75l-3.45-3.5c-1-1.05-2.65-1.05-3.65 0l-2.1 2.15c-1.05-.6-2.2-1.1-3.35-1.45v-3.05c0-1.45-1.15-2.65-2.55-2.65zm5.35 10.3c.6.4 1.35.3 1.85-.2l2.65-2.7 2.9 3-2.65 2.7c-.5.5-.55 1.3-.2 1.85.9 1.45 1.55 3.05 1.9 4.75.15.7.75 1.2 1.45 1.2h3.75v4.2h-3.75c-.7 0-1.3.5-1.45 1.2-.35 1.7-1 3.25-1.9 4.75-.35.6-.3 1.35.2 1.85l2.65 2.7-2.9 3-2.65-2.7c-.5-.5-1.25-.6-1.85-.2-1.4.95-2.95 1.6-4.6 1.95a1.5 1.5 0 0 0-1.15 1.45v3.85h-4.1v-3.85c0-.7-.5-1.3-1.15-1.45-1.65-.4-3.2-1.05-4.6-1.95-.6-.4-1.35-.3-1.8.2l-2.65 2.7-2.9-3 2.65-2.7c.5-.5.55-1.3.2-1.85-.9-1.45-1.55-3.05-1.9-4.75-.15-.7-.75-1.2-1.45-1.2h-3.75v-4.2h3.75c.7 0 1.3-.5 1.45-1.2.35-1.7 1-3.25 1.9-4.75.35-.6.3-1.35-.2-1.85l-2.65-2.7 2.9-3 2.65 2.7c.5.5 1.25.6 1.8.2 1.4-.95 2.95-1.6 4.6-1.95a1.5 1.5 0 0 0 1.15-1.45v-3.85h4.1v3.85c0 .7.5 1.3 1.15 1.45 1.65.4 3.2 1.05 4.6 1.95",
    style: {
      fill: "url(#icon_data_variables-01_svg2__h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.38 38.66c-5.6.3-10.19 5.05-10.49 10.79-.15 3.2 1 6.35 3.25 8.65 2.1 2.15 4.9 3.35 7.85 3.35h.55c.8 0 1.45-.75 1.4-1.6 0-.85-.75-1.45-1.55-1.45-2.35.1-4.55-.75-6.2-2.45s-2.5-3.95-2.4-6.35c.2-4.25 3.6-7.7 7.7-7.95 2.35-.1 4.7.85 6.35 2.6 3.35 3.6 2.45 8.95-.3 11.74-.55.6-.55 1.55 0 2.15.6.6 1.5.6 2.1 0 1.95-2.05 3.15-4.85 3.3-7.7.15-3.1-.9-6.05-3-8.25-2.25-2.4-5.35-3.7-8.6-3.5l.05-.05Z",
    style: {
      fill: "url(#icon_data_variables-01_svg2__i)"
    }
  }));
};
export default SvgIconDataVariables01;